module.exports = __webpack_public_path__ + "img/cisco-4.70697b83.webp";